// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1j-yt","fileBtn":"File_fileBtn__1Q2v2","closeBtn":"File_closeBtn__2mAc0","fileSelected":"File_fileSelected__3TY_K","disabled":"File_disabled__2vS-c"};